<template>
  <div>
    <div>
      <div>
        <p class="bold">חלון מספר 1 מתוך 3</p>
      </div>
      <div>
        <p><b>Position Title *</b></p>
        <input v-model="position_title" class="outlined full_width" placeholder='מנהל צוות בחברת נדלן'>
      </div>
      <div>
        <p><b>Owner</b></p>
        <input v-model="owner" class="outlined full_width">
      </div>
      <div>
        <p><b>Message</b></p>
        <input v-model="message" class="outlined full_width">
      </div>
    </div>
    <div class="modal_footer" style="justify-content: space-between;">
      <a
        @click="continueToStepTwo()"
        :class="{ 'is-loading': is_loading }"
        class="button is-info"
        >המשך לשלב הבא</a
      >
      <p><b>שלב ראשון</b></p>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  name: 'create-position-step-one',
  props: ['payload'],
  data () {
    return {
      is_loading: false,
      position_title: '',
      owner: this.$utils.getOwner().name,
      message: ''
    }
  },
  methods: {
    continueToStepTwo () {
      if (this.position_title.length == 0) {
        this.$utils.emit('show_toast', { text: 'Position Title ריק' })
        return
      }
      this.is_loading = true
      this.$network_utils.createPosition({ title: this.position_title, current_company_id: this.payload.company_id, owner: this.owner, message: this.message, status: 'editing', active_at: new Date() })
        .then(response => {
          this.is_loading = false
          this.create({
            designator: 'create-position-step-two',
            component_name: 'ModalPosition',
            ignore_escape_button: true,
            data: response,
            modal_width: 1500,
            modal_title: 'Create new Position - חלון מספר 2 מתוך 2'
          })
          this.remove(this.payload)
          this.$utils.emit('show_toast', { text: 'success' })
        }).catch(() => {
          this.is_loading = false
          this.$utils.emit('show_toast', { text: 'ארעה שגיאה' })
        })
    },
    ...mapMutations('modals', ['remove', 'create'])
  }
}
</script>
